webpackJsonp([145084477943565],{

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Banners = __webpack_require__(11);
	
	var _PageHelpers = __webpack_require__(25);
	
	var _helperFunctions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportsFeed = function (_React$Component) {
	  _inherits(ReportsFeed, _React$Component);
	
	  function ReportsFeed() {
	    _classCallCheck(this, ReportsFeed);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ReportsFeed.prototype.render = function render() {
	    var data = this.props.data;
	
	    var page = data.mortyPage;
	    var reports = data.allReports.edges.map(function (d) {
	      return d.node;
	    });
	    var privacyRoute = '/about-us/reports/vr-privacy-policy/';
	
	    var privacyReport = reports.find(function (o) {
	      return o.route === privacyRoute;
	    });
	    var filtered = reports.filter(function (o) {
	      return o.route !== privacyRoute;
	    });
	
	    var listData = (0, _helperFunctions.findRecentStories)(filtered);
	    var bannerPage = listData.shift();
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Meta2.default, { page: page }),
	      _react2.default.createElement('div', { className: 'list-feed ' + page.title }),
	      _react2.default.createElement(_Banners.ListFeedBanner, { page: page, latest: bannerPage }),
	      _react2.default.createElement(
	        'div',
	        { className: 'pt2 pb3 pt3-l pb5-l flex flex-column items-center justify-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'w-100 mw-1060 three-up-grid' },
	          listData.map(function (d) {
	            return _react2.default.createElement(_PageHelpers.ListFeedItem, { key: d.id, page: d });
	          }),
	          _react2.default.createElement(_PageHelpers.ListFeedItem, { page: privacyReport })
	        )
	      )
	    );
	  };
	
	  return ReportsFeed;
	}(_react2.default.Component);
	
	exports.default = ReportsFeed;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	var previewQuery = exports.previewQuery = '\nquery ReportsFeed($id: String!) {\n  mortyPage(id: { eq: $id }) {\n    title\n    route\n    subtitle\n    route\n    metaTitle\n    metaDescription\n    metaKeywords\n  }\n  allReports: allMortyPage(filter: {\n    route: { ne: "/dummy-page" }\n    section: { eq: "Reports" }\n}) {\n    edges {\n      node {\n        id\n        title\n        route\n        template\n        section\n        publishedDate\n        updatedAt\n        abstractPhotoAltText\n        abstractPhotoFocalPointX\n        abstractPhotoFocalPointY\n        abstractPhoto {\n          url\n        }\n      }\n    }\n  }\n}\n';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-reports-feed-js-001e2589a4a3c040b85b.js